<ion-header class="header" mode="md">
  <ion-toolbar mode="md">
    <ion-title class="ion-text-center header-title">{{ 'SET_NEW_PASSWORD.TITLE' | translate }}</ion-title>

    <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
      <ion-button [routerLink]="['/auth', 'prijava']" replaceUrl class="header-buttons__btn">
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>
    </ion-buttons>

     <app-top-right color="secondary" slot="end"></app-top-right>

  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col offset-lg="4" offset-md="3" offset-sm="2" size-sm="8" size-md="6" size-lg="4">

        <app-set-new-password-form></app-set-new-password-form>
        
      </ion-col>

    </ion-row>
  </ion-grid>
</ion-content>